import { Injectable } from '@angular/core';
import { DataService } from './data.service'; //
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private data: DataService) {}

  add(payload: any, message?: string): Observable<any> {
    return this.data.post('files/add', payload, message);
  }

  updateOrder(payload: any, message?: string): Observable<any> {
    return this.data.post('files/order', payload, message);
  }

  delete(id: number, message?: string): Observable<any> {
    return this.data.delete(`files?id=${id}`, message);
  }
}
